
let baseURL;
let siteURL;
let domain;
let imgURL

switch (process.env.NODE_ENV) {
    case 'development':
        baseURL = '/api';
        imgURL = 'https://oss.bee.kuchuangnet.com';


        //siteURL = 'https://server.aoying.kuchuangnet.com/';
        //domain = 'yunlifang.kuchuangnet.com';  //总公司
        //domain = 'server.aoying.kuchuangnet.com3';      //运立方

        break;
    case 'production':
        /*统一配置*/
        baseURL = '/prod-api';
        imgURL = 'https://oss.bee.kuchuangnet.com';

        /*总公司*/
        /*baseURL = 'https://h5.aoying.kuchuangnet.com/stage-api';
        siteURL = 'https://h5.aoying.kuchuangnet.com';
        domain = 'https://aoying.kuchuangnet.com';*/

        break;
}

export default {
    baseURL,
    siteURL,
    domain,
    imgURL
}
